export default __webpack_public_path__ + "static/media/Kosmos1266.117e8f0b.PNG";